/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
 
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { ShoppingListSealedDateBase } from 'shared/dbo/ShoppingListSealedDate';

export interface ShoppingListSealedDateIndexedDb {
	id: string;
	shoppingDate: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isShoppingListSealedDateIndexedDb = (obj: unknown): obj is ShoppingListSealedDateIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ shoppingDate: unknown }>(obj, 'shoppingDate') || !(typeof obj.shoppingDate === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: ShoppingListSealedDateBase): ShoppingListSealedDateIndexedDb => ({
	id: obj.id.toString(),
	shoppingDate: obj.shoppingDate.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: ShoppingListSealedDateIndexedDb): ShoppingListSealedDateBase => ({
	id: UUID.fromString(obj.id),
	shoppingDate: Temporal.PlainDate.from(obj.shoppingDate),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdShoppingListSealedDate: LocalDatabaseTableDefinition<ShoppingListSealedDateBase, ShoppingListSealedDateIndexedDb> = {
	tableName: 'shoppingListSealedDates',
	indexColumns: ['shoppingDate'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
